import React from "react";

export const RegSkeleton = () => {
    return (
        <div className="skeleton-container">
            <div className="skeleton-header"></div>
            <div className="skeleton-content">
                <div className="skeleton-title"></div>
                <div className="skeleton-text"></div>
                <div className="skeleton-text"></div>
                <div className="skeleton-button"></div>
            </div>
        </div>
    );
};

export const UcpSkeleton = () => {
    return (
        <div className="skeleton-container">
            <div className="skeleton-header"></div>
            <div className="skeleton-content">
                <div className="skeleton-title"></div>
                <div className="skeleton-cards">
                    <div className="skeleton-card"></div>
                    <div className="skeleton-card"></div>
                    <div className="skeleton-card"></div>
                    <div className="skeleton-card"></div>
                </div>
            </div>
        </div>
    );
};

export default RegSkeleton;
